import m from "../../geodata/es2015/singaporeLow";
window.am4geodata_singaporeLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/singaporeLow.js
// module id = null
// module chunks = 